import { personalNumberMaskProps } from 'mrshoebox-ui-components/src/helpers/countrySpecific'

export function personalNumber (value) {
  return personalNumberMaskProps.normalize(value)
}

export const normalizeNegativeValue = (value) => value < 0 ? Math.abs(value).toString() : value
